import { useState } from "react";
import classnames from 'classnames';
import UserPersonalInfo from "./UserPersonalInfo/UserPersonalInfo";
import { ByzzerMask } from "../ByzzerMask/ByzzerMask";
import { NotificationPreferences } from "./NotificationPreferences";
import './UserAccountInfo.scss';

const baseClassName = 'user-account-info';

export const UserAccountInfo = () => {
    const [loading, setLoading] = useState<boolean>(false);

    return (
        <div className={classnames(`${baseClassName}`)}>
            <ByzzerMask show={loading} loading={loading} isFullScreen={true}>Saving Account Info...</ByzzerMask>
            
            <div className={classnames(`${baseClassName}__display`)}>
                <UserPersonalInfo />
                <NotificationPreferences setLoading={setLoading} />
            </div>
        </div>
    );

};

export default UserAccountInfo;
